import { FC } from 'react'
import styles from './index.module.scss'

type Props = {
  onClickEdit?: () => void
  onClickDelete: () => void
  showDuplicateButton?: boolean
  onClickDuplicate?: () => void
  isDeleteOnly?: boolean
}

export const EditAndDeleteButtons: FC<Props> = ({
  onClickEdit,
  onClickDelete,
  showDuplicateButton = false,
  onClickDuplicate,
  isDeleteOnly = false,
}) => {
  if (isDeleteOnly) {
    return (
      <div className={styles.container}>
        <button type='button' onClick={onClickDelete}>
          Delete
        </button>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <button type='button' onClick={onClickEdit}>
        Edit
      </button>{' '}
      {showDuplicateButton && (
        <>
          /{' '}
          <button type='button' onClick={onClickDuplicate}>
            Duplicate
          </button>{' '}
        </>
      )}
      /{' '}
      <button type='button' onClick={onClickDelete}>
        Delete
      </button>
    </div>
  )
}
